import Popper from 'popper.js';

/**
 * Compensates for CSS `zoom` on document.documentElement in Popper.js v1 calculations.
 * In modern Chromium browsers, `getBoundingClientRect()` returns zoom-scaled coordinates,
 * which causes Popper.js v1 to double-multiply coordinates when positioning elements with
 * CSS translate3d inside a zoomed document.
 */
export function installPopperZoomFix() {
    if (!Popper || !Popper.Defaults || !Popper.Defaults.modifiers) {
        return;
    }

    Popper.Defaults.modifiers.applyZoomFix = {
        order: 50,
        enabled: true,
        fn(data) {
            const zoom = (typeof document !== 'undefined' && parseFloat(document.documentElement.style.zoom)) || 1;
            if (zoom === 1 || !data || !data.offsets || !data.offsets.reference || data.offsets.reference._zoomAdjusted) {
                return data;
            }
            data.offsets.reference._zoomAdjusted = true;

            // Normalize reference offsets to unzoomed CSS layout coordinates
            data.offsets.reference.left /= zoom;
            data.offsets.reference.top /= zoom;
            data.offsets.reference.width /= zoom;
            data.offsets.reference.height /= zoom;
            data.offsets.reference.right = data.offsets.reference.left + data.offsets.reference.width;
            data.offsets.reference.bottom = data.offsets.reference.top + data.offsets.reference.height;

            // Recompute initial popper offsets in unzoomed CSS coordinates
            const popperRect = {
                width: data.offsets.popper.width,
                height: data.offsets.popper.height
            };
            const placement = data.placement.split('-')[0];
            const isHoriz = ['right', 'left'].indexOf(placement) !== -1;
            const mainSide = isHoriz ? 'top' : 'left';
            const secondarySide = isHoriz ? 'left' : 'top';
            const measurement = isHoriz ? 'height' : 'width';
            const secondaryMeasurement = !isHoriz ? 'height' : 'width';

            data.offsets.popper[mainSide] = data.offsets.reference[mainSide] + data.offsets.reference[measurement] / 2 - popperRect[measurement] / 2;
            if (placement === secondarySide) {
                data.offsets.popper[secondarySide] = data.offsets.reference[secondarySide] - popperRect[secondaryMeasurement];
            } else {
                const hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
                const oppositeSide = secondarySide.replace(/left|right|bottom|top/g, matched => hash[matched]);
                data.offsets.popper[secondarySide] = data.offsets.reference[oppositeSide];
            }
            data.offsets.popper.left = Math.round(data.offsets.popper.left);
            data.offsets.popper.top = Math.round(data.offsets.popper.top);
            data.offsets.popper.right = data.offsets.popper.left + data.offsets.popper.width;
            data.offsets.popper.bottom = data.offsets.popper.top + data.offsets.popper.height;

            return data;
        }
    };
}
